import React from 'react'
import logo from '../assets/licharz.svg'

export default function Logo() {

  return (
      <img src={logo} style={{height:'40px', padding:'0px', margin:'0px'}}/>
    )
}
